const styles = {
  menu: {
    margin: '0 1em !important',
    borderRadius: '0 !important',
    background: 'transparent !important',
    boxShadow: 'none !important',
    border: 'none !important',
  },
  menuItem: {
    color: '#999 !important',
    display: 'block !important',
    fontSize: ' .9375rem !important',
    margin: '0 .9375em !important',
    padding: '1.9375rem .5rem 1.8125rem .5rem !important',
    textDecoration: 'none !important',
    borderBottom: '.1875em solid transparent !important',
    '&:hover': {
      color: '#999 !important',
      backgroundColor: '#fff !important',
    },
    '&:before': {
      backgroundColor: 'transparent !important',
      width: '0',
    },
    borderRadius: '0 !important',
  },
  active: {
    borderBottom: '.1875em solid #683caf !important',
    color: '#683caf !important',
    backgroundColor: '#FFF !important',
    '&:hover': {
      color: '#683caf !important',
    },
  },
};

export default styles;
